import React, { useEffect, useState, useRef } from 'react';
import { DialogContent, IconButton, Icon } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LibraryIcon from '@mui/icons-material/AutoStories';
import {
  TaskCreateDialog,
  TC_FORM_STYLE,
  TC_TITLE_STYLE,
  TC_SCREEN_WIDTH,
  TC_SCREEN_CONTAINER,
  TC_SCREEN_CONTAINER_MOBILE,
  StyledAppBar,
  StyledToolbar,
  Title,
  Status,
  StatusIcon,
  Container,
  BarTitle,
  ButtonContainer,
  TagButton,
  TagContainer,
  TagReference,
  SuperText,
  TagText,
  TagOption,
  TagBox,
  TagName,
  TagDescription,
  TagLink,
  SubmitButtonContainer,
  SubmitButton,
  DoubleIcon,
  SubscriptAddIcon,
  SubmitBtnText,
  LoadingContainer,
} from './TaskCreate.styles';
import { get, set, size, last, sortBy, first } from 'global/lib/lodash';
import Form from 'global/components/form';
import Styles, { useScreen, Loader } from 'global/styles';
import Alert from '@mui/material/Alert';
import TaskTag from './TaskTag';
import ScoreIcon from 'global/components/ScoreIcon';
import sendData from 'redux/actions/sendData';
import { useDispatch } from 'react-redux';
import { addNewTask } from 'redux/actions/view';
import qs from 'qs';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { useAccessEdition } from 'global/utils/edition';
import { Link } from 'react-router-dom';
import { UploadFiles } from 'redux/actions/imageUploader';
import { getDisplayValue } from 'global/utils/getDisplayScore';
import { useUser } from 'global/hooks/useUser';
import { LI } from '../../report/Highlights';
import moment from 'moment';
import { fixWeirdDateIssue } from '../../../global/components/form';
import { taskOptions, SETTINGS } from '../../admin/account-settings';
import { getAccountSetting } from 'redux/actions/userLogin';
import { Text } from '../../../global/components/text';
import { getCustomFieldInputs, getCloseoutFromTaskType, getCloseoutDefaults, getStandardFieldRequirements, UploadCustomFieldMedia } from '../task-type-utils';
import { splitMediaByType } from 'global/utils/mediaUtils';

export const RenderTag = ({ tag, showLink }) => {
  const hasReportSection = get(tag, 'reportSection');
  const checkpointId = get(tag, 'checkpointId');
  const checklistId = get(tag, 'checklistId');

  const params = [
    { url: `/edition-documents` },
    {
      build: ['editionDocuments'],
      useEffect: true,
      waitFor: showLink ? checklistId : null,
      params: { filter: { documentable_type: 'checklist', documentable_id: checklistId } },
      showAlert: false,
      transformData: (d) => last(d),
    },
  ];

  const { data } = useRetrieveData(...params);
  const editionId = showLink ? get(data, 'editionId') : null;
  const bool = useAccessEdition(editionId);

  const scscore = useRetrieveData(
    { url: `/scorecard-scores/${get(tag, 'scorecardScoreId')}` },
    {
      build: ['scorecardScores'],
      waitFor: !!get(tag, 'scorecardScoreId') ? undefined : null,
      transformData: (d) => {
        return first(d);
      },
    }
  );

  const getLink = (() => {
    if (bool) {
      return `/library/${editionId}/document/${get(data, 'classificationId')}${checkpointId ? `?hl=${checkpointId}` : ''}`;
    }
    return '';
  })();

  const superSet = get(data, 'superset');

  if (hasReportSection) {
    return (
      <>
        <LI li={hasReportSection} collapseContentOnly />
      </>
    );
  }

  const score = get(tag, 'score');
  const displayValue = getDisplayValue({ value: score }, get(tag, 'scorecardConfig', null));
  const sibscore = get(scscore, 'data.statusSiblings.0');

  return (
    <>
      {superSet && <SuperText>{get(superSet, 'name')}</SuperText>}
      <TagContainer>
        <TagText>
          {!!checkpointId && <TagOption>{displayValue}</TagOption>}
          <TagBox>
            <ScoreIcon center score={!!checkpointId ? score : undefined} />
          </TagBox>
          <TagName>{get(tag, 'name', '')}</TagName>
          <TagDescription>{!!checkpointId ? get(tag, 'criteria') || get(tag, 'description') : `General Observation: ${get(tag, 'pssvChecklist.name')}`}</TagDescription>
        </TagText>
      </TagContainer>

      {!!sibscore && (
        <>
          <Text bold>TARGET</Text>
          <TagContainer>
            <TagText as="div">
              {!!checkpointId && <TagOption>{getDisplayValue({ value: sibscore.score }, get(tag, 'scorecardConfig', null))}</TagOption>}
              <TagBox>
                <ScoreIcon center score={!!checkpointId ? sibscore.score : undefined} />
              </TagBox>
              <TagName>{get(tag, 'name', '')}</TagName>
              <TagDescription>{get(sibscore, 'criteria') || get(sibscore, 'description')}</TagDescription>
            </TagText>
          </TagContainer>
        </>
      )}

      {showLink && getLink && (
        <TagLink>
          <TagReference variant="body2" component={Link} to={getLink}>
            <LibraryIcon />
            Go to Library
          </TagReference>
        </TagLink>
      )}
    </>
  );
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const [formLoading, setFormLoading] = useState(false);
  const [error, setError] = useState();
  const [tag, setTag] = useState();
  const [formState, setFormState] = useState({});
  const [defaultedTradeIds, setDefaultedTradeIds] = useState([]);
  const [tagModal, setTagModal] = useState(false);
  const [tagName, setTagName] = useState();
  const { me } = useUser();
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const lastCreatedTaskRef = useRef(null);

  const styles = Styles();
  const { isMobileXS } = useScreen();

  const usersList = useRetrieveData(
    { url: '/users' },
    {
      waitFor: get(props, 'realmItem.realm.id', null),
      build: ['users'],
      params: { filter: { content_realm_id: get(props, 'realmItem.realm.id') } },
      useCache: { reload: 1 },
    }
  );

  const reset = (formState = {}) => {
    setFormState(formState);
    setDefaultedTradeIds([]);
    setTagModal(false);
    setError();
    setTag();
    setFormLoading(false);
  };

  const getTradeIds = (trades = []) => (trades || []).map((trade) => String(get(trade, 'id'))).filter((id) => id && id !== 'undefined' && id !== 'null');

  useEffect(() => {
    setDefaultedTradeIds((prev) => {
      if (!size(prev)) {
        return prev;
      }

      const selectedTradeIds = new Set(getTradeIds(get(formState, 'tradeTypes', [])));
      const next = prev.filter((id) => selectedTradeIds.has(id));
      return next.length === prev.length ? prev : next;
    });
  }, [
    get(formState, 'tradeTypes', [])
      .map((trade) => get(trade, 'id'))
      .toString(),
  ]);

  useEffect(() => {
    if (props.open) {
      lastCreatedTaskRef.current = null;
    }
  }, [props.open]);

  const handleClose = async (tsk) => {
    const taskToPass = tsk || lastCreatedTaskRef.current;
    lastCreatedTaskRef.current = null;
    await props.onClose(taskToPass);
    reset();
  };

  const formatData = async (values) => {
    const relationships = {};

    let tresult;
    if (tag) {
      const selectedOption = get(tag, 'pssvCheckpoint.selectedOption');
      const sco = get(tag, `pssvCheckpoint.scorecardOptions.${get(selectedOption, 'index')}`);
      tresult = await sendData({
        url: '/scorecard-scores',
        method: 'post',
        data: {
          data: {
            type: 'scorecard-scores',
            attributes: {
              scorecard_id: get(tag, 'scorecardId'),
              checklist_id: get(tag, 'pssvChecklist.id'),
              checkpoint_id: get(tag, 'pssvCheckpoint.id'),
              scorecard_option_id: get(sco, 'id'),
              criteria: [get(tag, 'pssvCheckpoint.description'), get(sco, 'criteria')].filter(Boolean).join(' '),
              score: get(sco, 'value', 0),
            },
          },
        },
      });
    }

    const { images: splitImages, documents: splitDocs } = splitMediaByType(get(formState, 'media', []));

    const attributes = {
      name: get(values, 'name'),
      description: get(values, 'description'),
      status: 0,
      realm_id: get(props, 'realmItem.realm.id'),
      scorecard_score_id: get(tresult, 'data.data.id'),
      checkpoint_id: get(tag, 'pssvCheckpoint.id'),
      due_date: get(formState, 'dueDate'),
      images: splitImages.map((p) => ({ ...p, name: p.path || p.name, caption: get(p, 'caption', '') })),
      meta: {
        ...get(formState, 'meta', {}),
      },
      ...(props.taskType ? { task_type_id: String(props.taskType.id) } : {}),
    };

    const assignees = get(formState, 'assignedTo');
    set(relationships, 'assignees', {
      data: size(assignees) ? assignees.map((e) => ({ type: 'users', role: 'assignee', id: e.id })) : [{ type: 'users', role: 'assignee', id: me.id }],
    });

    set(relationships, 'authors', {
      data: [{ type: 'users', role: 'author', id: get(me, 'id', '').toString() }],
    });

    const data = {
      data: {
        type: 'tasks',
        attributes,
        relationships,
      },
    };

    const tradeTypes = get(formState, 'tradeTypes');
    if (size(tradeTypes)) {
      set(relationships, 'tradeTypes', {
        data: (tradeTypes || []).map((t, i) => ({ type: 'trade-types', id: t.id, pivot: { order: `${i}` } })),
      });
    }

    if (size(attributes.images)) {
      await UploadFiles(data);
    }

    const documents = splitDocs.map((f) => ({ ...f, name: get(f, 'file.name', f.name) }));
    if (size(documents)) {
      set(data, 'data.attributes.files', documents);
      await UploadFiles(data, { attributeType: 'files', isImage: false, collection_name: 'task-files' });
    }

    if (props.taskType) {
      await UploadCustomFieldMedia(data, {
        rawCfv: get(formState, 'custom_field_values') || {},
        taskTypeId: String(props.taskType.id),
      });
    }

    return data;
  };

  const formSubmit = async (addAnother = false) => {
    try {
      setFormLoading(true);
      const data = await formatData(formState);
      const createdTask = await sendData({
        url: '/tasks',
        method: 'post',
        data,
      });
      const tsk = get(createdTask, 'data.data');
      const include =
        'images,files,assignees,viewers,authors,comments,comments.author,comments.images,comments.files,realm,scorecardScore,scorecardScore.checklist,scorecardScore.checkpoint,tradeTypes';
      const fullTask = await sendData(
        {
          url: `/tasks/${tsk.id}?${qs.stringify({ include })}`,
          method: 'get',
        },
        { normalize: { build: ['tasks'] } }
      );
      lastCreatedTaskRef.current = tsk;
      dispatch(addNewTask(get(fullTask, '0')));
      if (addAnother) {
        const assignedTo = get(formState, 'assignedTo');
        reset({ assignedTo });
      } else {
        await handleClose(tsk);
      }
      setFormLoading(false);
    } catch (err) {
      setFormLoading(false);
      setError(`${err.message}. Please try again.`);
    }
  };

  const formUpdate = (vals) => {
    for (let k in vals) {
      set(formState, k, vals[k]);
    }
    setFormState({ ...formState });
    if (formRef.current) {
      const result = formRef.current.canContinue(true);
      setIsFormValid(result.passes);
    }
  };

  const clearTag = () => {
    setTag();
    setTagName();
    setDefaultedTradeIds([]);
    if (tagName === get(formState, 'name')) {
      formRef.current.updateState('name', '');
    }
  };

  const onTagSelected = (tags) => {
    setTag(tags);
    setDefaultedTradeIds([]);
    if (!get(formState, 'name')) {
      const clname = get(tags, 'pssvChecklist.name');
      const cpname = get(tags, 'pssvCheckpoint.name');
      const name = clname + (cpname ? `: ${cpname}` : '');
      setTagName(name);
      formRef.current.updateState('name', name);
    }
  };

  const [customFieldErrors, setCustomFieldErrors] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);

  const handleSaveClick = (addAnother) => {
    const result = formRef.current.validateRequired();
    if (result.passes) {
      setCustomFieldErrors([]);
      formSubmit(addAnother);
    }
  };

  return (
    <TaskCreateDialog className="task-create-dialog" fullScreen disableScrollLock disableEscapeKeyDown open={props.open} onClose={() => handleClose()}>
      <StyledAppBar color="secondary">
        <StyledToolbar>
          <IconButton edge="start" color="inherit" onClick={() => handleClose()} aria-label="Close" size="large">
            <CloseIcon />
          </IconButton>

          <BarTitle>
            <Title variant="h5">{props.taskType ? `Create Task - ${props.taskType.name}` : 'Create Task'}</Title>
          </BarTitle>

          <Status variant="h6">
            {get(props, 'realmItem.realmName', '')}
            <StatusIcon>
              <Icon>place</Icon>
            </StatusIcon>
          </Status>
        </StyledToolbar>
      </StyledAppBar>

      {!formLoading && (
        <DialogContent>
          <Container>
            {error && (
              <Alert
                severity="error"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setError();
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                {error}
              </Alert>
            )}

            <ButtonContainer>
              <TagButton isRemove={!!tag} variant="outlined" startIcon={<Icon>{tag ? 'close' : 'label'}</Icon>} onClick={tag ? () => clearTag() : () => setTagModal(true)}>
                {tag ? 'REMOVE LINK' : 'ADD LINK'}
              </TagButton>

              {tag && <RenderTag tag={tag} />}
            </ButtonContainer>

            <Form
              loading={formLoading}
              showAllScreens={true}
              formStyle={TC_FORM_STYLE}
              onSubmit={formSubmit}
              onFormState={formUpdate}
              ref={formRef}
              useHeight={false}
              screens={[
                {
                  title: '',
                  titleStyle: TC_TITLE_STYLE,
                  screenContainerStyle: isMobileXS ? TC_SCREEN_CONTAINER_MOBILE : TC_SCREEN_CONTAINER,
                  screenContainer: {
                    props: {
                      className: TC_SCREEN_WIDTH,
                    },
                  },
                  inputs: (() => {
                    const stdReqs = props.taskType ? getStandardFieldRequirements(props.taskType) : [];
                    const isFieldRequired = (fid) => stdReqs.find((f) => f.id === fid)?.is_required;
                    const isFieldEnabled = (fid) => {
                      const f = stdReqs.find((s) => s.id === fid);
                      return f ? f.is_enabled !== false : true;
                    };

                    const defaultFieldMap = {
                      f_title: {
                        id: 'name',
                        type: 'TextField',
                        required: isFieldRequired('f_title'),
                        defaultValue: () => get(formState, 'name'),
                        props: { placeholder: 'Enter Title' },
                      },
                      f_description: {
                        id: 'description',
                        type: 'TextField',
                        required: isFieldRequired('f_description'),
                        defaultValue: () => get(formState, 'description'),
                        props: { placeholder: props.taskType ? `Describe your ${props.taskType.name}` : 'Describe your task', maxRows: 5, multiline: true },
                      },
                      f_assignee: {
                        id: 'assignedTo',
                        type: 'UserSelect',
                        required: isFieldRequired('f_assignee'),
                        defaultValue: () => get(formState, 'assignedTo', []),
                        data: () => usersList.data,
                        props: { label: 'Assigned To' },
                      },
                      f_due_date: {
                        id: 'dueDate',
                        type: 'KeyboardDatePicker',
                        required: isFieldRequired('f_due_date'),
                        defaultValue: () => (get(formState, 'dueDate') ? moment(get(formState, 'dueDate')) : undefined),
                        props: { label: 'Due Date', convert: (d) => fixWeirdDateIssue(d, !formState.dueDate) },
                      },
                      f_trade: {
                        id: 'tradeTypes',
                        type: 'TradeSelect',
                        required: isFieldRequired('f_trade'),
                        defaultValue: () => get(formState, 'tradeTypes', []),
                        props: {
                          label: 'Trade Types',
                          checklist: get(tag, 'pssvChecklist'),
                          mutedTradeIds: defaultedTradeIds,
                          onChecklistTradesLoaded: (trades = []) => {
                            if (tag && !size(get(formState, 'tradeTypes', []))) {
                              setDefaultedTradeIds(getTradeIds(trades));
                            }
                          },
                        },
                      },
                      f_media: {
                        id: 'media',
                        type: 'DropArea',
                        required: isFieldRequired('f_media'),
                        defaultValue: () => sortBy(get(formState, 'media', []), 'orderColumn'),
                        props: {
                          label: 'Media',
                          sortable: true,
                          assessment: props.assessment,
                          uploadAllNew: true,
                          shouldUpdateOnCaptionChange: true,
                          collection: 'task-images',
                          notAllowed: ['tag'],
                          bothMode: true,
                          accept: null,
                        },
                      },
                    };

                    const metaInput = {
                      id: 'meta',
                      type: 'Checkbox',
                      options: props.taskType ? getCloseoutFromTaskType(props.taskType) : taskOptions(),
                      defaultValue: () => (props.taskType ? getCloseoutDefaults(props.taskType) : getAccountSetting(SETTINGS.taskDefault)),
                      props: { label: 'Requirements' },
                    };

                    const fieldOrder = get(props, 'taskType.field_order');
                    if (fieldOrder && Array.isArray(fieldOrder)) {
                      const customInputMap = {};
                      if (props.taskType) {
                        getCustomFieldInputs(props.taskType, formState, { errors: customFieldErrors }).forEach((input) => {
                          const cfId = input.id.replace('custom_field_values.', '');
                          customInputMap[cfId] = input;
                        });
                      }

                      const ordered = [];
                      fieldOrder.forEach((fid) => {
                        if (fid === 'f_documents') return;
                        if (defaultFieldMap[fid] && isFieldEnabled(fid)) {
                          ordered.push(defaultFieldMap[fid]);
                        } else if (customInputMap[fid]) {
                          ordered.push(customInputMap[fid]);
                        }
                      });

                      Object.keys(customInputMap).forEach((cfId) => {
                        if (!fieldOrder.includes(cfId)) {
                          ordered.push(customInputMap[cfId]);
                        }
                      });

                      ordered.push(metaInput);
                      return ordered;
                    }

                    return [
                      defaultFieldMap.f_title,
                      ...(isFieldEnabled('f_description') ? [defaultFieldMap.f_description] : []),
                      ...(isFieldEnabled('f_assignee') ? [defaultFieldMap.f_assignee] : []),
                      ...(isFieldEnabled('f_due_date') ? [defaultFieldMap.f_due_date] : []),
                      ...(isFieldEnabled('f_trade') ? [defaultFieldMap.f_trade] : []),
                      ...(isFieldEnabled('f_media') ? [defaultFieldMap.f_media] : []),
                      ...(props.taskType ? getCustomFieldInputs(props.taskType, formState, { errors: customFieldErrors }) : []),
                      metaInput,
                    ];
                  })(),
                },
              ]}
            />

            <SubmitButtonContainer>
              <SubmitButton
                disabledLook={!isFormValid}
                startIcon={
                  <DoubleIcon>
                    <Icon>check</Icon>
                    <SubscriptAddIcon>add</SubscriptAddIcon>
                  </DoubleIcon>
                }
                variant={'contained'}
                color="secondary"
                onClick={() => handleSaveClick(true)}
              >
                <SubmitBtnText>Save & Add</SubmitBtnText>
              </SubmitButton>

              <SubmitButton
                disabledLook={!isFormValid}
                startIcon={
                  <DoubleIcon>
                    <Icon>check</Icon>
                  </DoubleIcon>
                }
                variant={'contained'}
                color="secondary"
                onClick={() => handleSaveClick()}
              >
                <SubmitBtnText>Save & Close</SubmitBtnText>
              </SubmitButton>
            </SubmitButtonContainer>
          </Container>
        </DialogContent>
      )}

      {formLoading && (
        <LoadingContainer className={styles.centerColumn}>
          <Loader size={40} />
        </LoadingContainer>
      )}

      <TaskTag open={tagModal} onTagSelected={onTagSelected} onClose={() => setTagModal(false)} />
    </TaskCreateDialog>
  );
};
